import { Children, ReactElement, ReactNode } from 'react';
import styles from './ui-filter.module.scss';

type UIFilterGroupProps = {
    children?: ReactNode;
};
export function UIFilterGroup(props: UIFilterGroupProps): ReactElement {
    const { children } = props;

    const childrenWithDividers: ReactNode[] = [];
    Children.forEach(children, (child, index) => {
        // Add the child itself
        childrenWithDividers.push(child);

        // If it's not the last child, add a divider
        if (index < Children.count(children) - 1) {
            childrenWithDividers.push(
                <div key={`divider-${index}`} className={styles.divider} />
            );
        }
    });

    return <div className={styles.groupContainer}>{childrenWithDividers}</div>;
}
